import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TextArea.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "TextField",
    {
      attrs: {
        "is-focused": _vm.focused,
        "is-invalid": _vm.isInvalid,
        "is-loading": _vm.isLoading,
        disabled: _vm.isLoading
      }
    },
    [
      _c(
        "textarea",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.text,
                  expression: "text"
                }
              ],
              ref: "textarea",
              style: {
                height: _vm.currentHeight,
                width: _vm.width,
                maxHeight: _vm.maxHeight
              },
              attrs: {
                rows: _vm.rows,
                disabled: _vm.isLoading,
                auto: _vm.height === "auto"
              },
              domProps: { value: _vm.text },
              on: {
                keydown: _vm.resize,
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.text = $event.target.value;
                  },
                  _vm.resize
                ],
                focus: _vm.onFocus,
                blur: _vm.onBlur
              }
            },
            "textarea",
            _vm.$attrs,
            false
          ),
          _vm.listeners
        )
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-44962024";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/TextArea.vue.js